export default function BeemoClock() {
	return (
		<iframe
			src='/clock/index.html'
			title='Beemo Date and Time Page'
			style={{ width: '100%', height: '100%', border: 'none' }}
		/>
	);
}
